const { fetchAllWordpress } = require('../../../../utils/fetch-wp');
const postCategories = require('../../../../data/categories.json');
const fetchWordpress = require('../../../../api/wordpress');

async function getInitialProps(props) {
  const { category } = props;
  if (!category) return props;
  try {
    const { name: title } = await fetchWordpress(`categories/${category}`);
    const initialData = await fetchAllWordpress(`posts?categories=${category}`);
    const initialTags = await fetchAllWordpress('tags');
    const parsedTags = initialTags.reduce(
      (acc, { id, name }) => ({
        ...acc,
        [id]: { name }
      }),
      {}
    );
    const articles = initialData
      .filter(
        ({ categories }) => !categories.includes(9) && !categories.includes(42)
      ) // don't take components or advertiesements
      .map(data => {
        const { title, date, slug, categories, acf, tags } = data;
        const { default_fields } = acf;
        return {
          ...default_fields,
          image:
            default_fields.featured_image && default_fields.featured_image.name,
          title: title.rendered,
          date,
          slug: `/${slug}`,
          categories: categories.map(cat => postCategories[cat].name),
          influencer: categories.includes(4) && parsedTags[tags[0]] ? parsedTags[tags[0]].name : null,
        };
      });
    return {
      title,
      articles: articles.slice(0, 8),
      category,
    };
  } catch (e) {
    console.log('ERROR', e);
    return props;
  }
}

module.exports = {
  getInitialProps
};
